import { cn } from "@shared/lib/style";
import { formatDateTime } from "@shared/lib/utils";
import { BaseImage } from "@shared/ui/base-image";

export interface DetailMainProps {
  imageUrl: string;
  category: string;
  title: string;
  summary: string;
  date: string;
  author: string;
  avatarUrl: string;
}

const styleMap = {
  desktop: {
    section: "mx-auto flex h-[600px] max-w-[1280px] min-w-[1280px] pt-[56px]",
    image: "h-full w-[50%] object-cover",
    titleBox: "w-[50%] bg-surface-soft pt-[60px] px-[40px]",
  },
  mobile: {
    section:
      "max-sm:flex max-sm:flex-col max-sm:min-w-auto max-sm:w-full max-sm:min-h-[686px] max-sm:h-auto",
    image: "max-sm:w-full max-sm:h-[400px]",
    titleBox: "max-sm:w-full max-sm:py-[40px] max-sm:px-[20px]",
    category: "",
  },
};

export function DetailMain({
  title,
  summary,
  date,
  author,
  category,
  imageUrl,
  avatarUrl,
}: DetailMainProps) {
  return (
    <section className={cn(styleMap.desktop.section, styleMap.mobile.section)}>
      <BaseImage
        alt={title}
        className={cn(styleMap.desktop.image, styleMap.mobile.image)}
        height={1200}
        preload
        src={imageUrl}
        width={4000}
      />
      <div className={cn(styleMap.desktop.titleBox, styleMap.mobile.titleBox)}>
        <div
          className={cn(
            "mb-[40px] flex flex-col gap-[30px]",
            "max-sm:mb-[30px] max-sm:gap-[20px]",
          )}
        >
          <div className="flex flex-col gap-[10px]">
            <span className="max-sm:text-body-5 font-semibold">{category}</span>
            <h1 className="max-sm:text-title-3 text-title-1 font-semibold">
              {title}
            </h1>
          </div>
          <p className="max-sm:text-body-3">{summary}</p>
        </div>
        <div
          className={cn(
            "flex flex-col gap-[10px] font-semibold",
            "max-sm:text-body-3 max-sm:flex-row-reverse max-sm:items-center max-sm:justify-end max-sm:gap-0",
          )}
        >
          <span>{formatDateTime(date, "yyyy.MM.dd (EEE)")}</span>
          <span className="mx-[10px] hidden h-[8px] w-px max-sm:block max-sm:bg-black/40" />
          <div className="flex items-center gap-[10px] max-sm:gap-[4px]">
            <figure className="h-[40px] w-[40px] overflow-hidden rounded-full bg-slate-300 max-sm:h-[24px] max-sm:w-[24px]">
              <BaseImage
                alt={author}
                className="h-full w-full"
                height={50}
                src={avatarUrl}
                width={50}
              />
            </figure>
            <span>{author}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
